export const all = ['cruises'] as const

export const detail = (id?: string) => [...all, id]
